<template>
  <div id="app">
    <div
      v-if="showLoader"
      class="app-loader">
      <LoadingSpinner />
    </div>
    <router-view/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import '@simplecast/styles/global.scss'
import { LoadingSpinner } from '@simplecast/styles'

export default {
  components: {
    LoadingSpinner
  },
  metaInfo () {
    return {
      titleTemplate: (titleChunk) => {
        // If undefined or blank then we don't need the -
        return titleChunk ? `${titleChunk} - Simplecast Dashboard` : 'Simplecast Dashboard'
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentAccount'
    ]),
    showLoader () {
      return !this.currentAccount || this.$route.name === 'overview'
    }
  }
}
</script>

<style lang="scss">
  #app {
    height: 100%;
  }
  .app-loader {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
    align-content: center;
  }
</style>
